import apiConfig from './apiConfig'

const APIS = {
  env: apiConfig.env,
  spell: apiConfig.spell,
  // 会员相关接口
  getV4CouponList: `${apiConfig.LXDOMAIN}vip/v4/couponList`, // 4.0会员中心-优惠券列表
  receiveCoupon: `${apiConfig.LXDOMAIN}vip/v4/receiveCoupon`, // 4.0会员中心-优惠券列表
}

export default APIS


// WEBPACK FOOTER //
// ./src/apis/vip.js